/*  iceberg-ui  */
import { IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Box, Typography } from '@mui/material';

/* Shared */
import { FontSizes } from 'application/Shared/Constants';

/* NPM */
import i18n from 'i18n';

/*  React  */
import React from 'react';

const { t } = i18n;

const StyleText = ({ style, text }) => (
    <Typography variant="p" style={{ ...style }}>
        {text}
    </Typography>
);

export const SSO = () => {
    const filters = [
        {
            children: [
                {
                    default: false,
                    icon: (
                        <IconWithVariant
                            key="googleSSO"
                            src="Google"
                            size={FontSizes[1]}
                            wrapperProps={{
                                display: 'flex',
                                justifyContent: 'center',
                                width: '30px'
                            }}
                        />
                    ),
                    key: 'googleSSO',
                    name: t('SSOTypes.filter.google')
                },
                {
                    default: false,
                    icon: (
                        <IconWithVariant
                            key="microsoftSSO"
                            src="Microsoft"
                            size={FontSizes[1]}
                            wrapperProps={{
                                display: 'flex',
                                justifyContent: 'center',
                                width: '30px'
                            }}
                        />
                    ),
                    key: 'microsoftSSO',
                    name: t('SSOTypes.filter.microsoft')
                },
                {
                    default: false,
                    icon: (
                        <IconWithVariant
                            key="icon_notAvailable"
                            src="Close"
                            size={FontSizes[1]}
                            wrapperProps={{
                                display: 'flex',
                                justifyContent: 'center',
                                width: '30px'
                            }}
                        />
                    ),
                    key: 'none',
                    name: t('SSOTypes.filter.notAvailable')
                }
            ],
            default: true,
            key: 'SSO',
            name: t('SSOTypes.filter.ssoCoverage')
        }
    ];

    const parameter = 'ssoType';
    const filterableOptions = [];

    filters.forEach((f) => {
        const { key, name, children } = f;

        filterableOptions.push({
            ...f,
            children: children.map((c) => c.key),
            parameter,
            parent: true,
            render: (
                <StyleText
                    style={{ fontSize: FontSizes[2], fontWeight: 600 }}
                    text={name}
                />
            ),
            value: key,
            visualOnly: true
        });

        children.forEach((c) => {
            filterableOptions.push({
                ...c,
                child: true,
                parameter,
                parentKey: key,
                render: (
                    <Box display="flex" alignItems="center">
                        {c.icon}
                        <StyleText
                            key={`text_${c.key}`}
                            style={{ fontSize: FontSizes[1] }}
                            text={c.name}
                        />
                    </Box>
                ),
                value: c.key
            });
        });
    });

    const headers = {
        filterable: true,
        filterableOptions,
        key: 'ssoType',
        name: 'Common.sso',
        sortable: false,
        sortableFieldType: 'string',
        sortableKey: 'ssoType',
        width: '10%'
    };

    return headers;
};
